import I18n from './vendor/i18n';
window.i18n = I18n;
window.DirectorRouter = require('./vendor/director.min.js').Router;
window.classNames = require('classnames');
require('./vendor/array-includes-polyfill.js');
require('./vendor/remove-outline.js');
require('./vendor/dataset-shim.js');
